import { Action } from '@ngrx/store';
import { ActiveDeliveriesActions, ActiveDeliveriesActionTypes } from './active-deliveries.actions';


export const activeDeliveriesFeatureKey = 'activeDeliveries';

export interface State {

}

export const initialState: State = {
  activeDeliveries: <any>{},
  error: <any>''
};

export function reducer(state = initialState, action: ActiveDeliveriesActions): State {
  switch (action.type) {

    case ActiveDeliveriesActionTypes.LoadActiveDeliveriess:
      return {
        ...state
      }

    case ActiveDeliveriesActionTypes.LoadActiveDeliveriessSuccess:
      return {
        ...state,
        activeDeliveries: action.payload.data,
        error: '',
      }

    case ActiveDeliveriesActionTypes.LoadActiveDeliveriessFailure:
      return {
        ...state,
        activeDeliveries: <any>{},
        error: action.payload.error,
      }

    default:
      return state;
  }
}
